<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Ekonomi och avgifter</h5>

    <h6 style="font-weight: 500;">Årsavgift</h6>
    <h6>{$selectedItem?.financial_obligations?.annual_fee?.payment_schedule ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.financial_obligations?.annual_fee?.calculation_method ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Pantsättning</h6>
    <h6>{$selectedItem?.financial_obligations?.pledge_fee ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Överlåtelseavgift</h6>
    <h6>{$selectedItem?.financial_obligations?.transfer_fee ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Uthyrninga av lägenhet</h6>
    <h6>{$selectedItem?.financial_obligations?.subletting_fee?.payment_terms ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.financial_obligations?.subletting_fee?.max_percentage ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.financial_obligations?.subletting_fee?.calculation_basis ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Dröjsmålsränta</h6>
    <h6>{$selectedItem?.financial_obligations?.late_payment_interest ?? "Uppgifter saknas"}</h6>
</div>